var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "date-input",
      class: {
        "date-input--disabled": _vm.disabled,
        "date-input--focused": _vm.focused,
        "date-input--error": _vm.error,
        "date-input--readonly": _vm.readonly
      }
    },
    [
      _c("FormInput", {
        ref: "input",
        class: {
          "primary-input--focused": _vm.focused,
          "primary-input--error": _vm.error
        },
        attrs: {
          id: _vm.id,
          name: _vm.name,
          label: _vm.label,
          "label-option": _vm.labelOption,
          placeholder: _vm.placeholder,
          icon: _vm.icon,
          required: _vm.required,
          disabled: _vm.disabled,
          readonly: "",
          error: _vm.error
        },
        on: {
          input: _vm.onInput,
          focus: _vm.onFocus,
          blur: _vm.onBlur,
          keyup: _vm.onKeyup,
          keydown: _vm.onKeydown
        },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _vm._v(" "),
      _vm.datePickerVisible && !_vm.readonly
        ? _c("FormInputDatePicker", {
            ref: "datepicker",
            staticClass: "date-input__date-picker",
            attrs: {
              initialSelectedDate: _vm.value,
              "min-date": _vm.minDate,
              "max-date": _vm.maxDate,
              isDateDisabled: _vm.isDateDisabled
            },
            on: { change: _vm.datePickerChangeHandler }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }